export const textTrim = (text: string, length = 80) => {
  if (text.length <= length) {
    return text;
  }
  return `${text.slice(0, length)}...`;
};
export const toLinkFormat = (text: string) => encodeURIComponent(`${text}`.trim());

export const fromLinkFormat = (text: string) => decodeURIComponent(`${text}`.trim());
